// test22
(22 && 0);
